import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function UniqueMechanism() {
  return <section className="w-full bg-midnight py-24 px-6" data-id="element-193">
      <div className="max-w-5xl mx-auto" data-id="element-194">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-195">
          <h2 className="font-display text-3xl md:text-5xl text-bone uppercase leading-tight" data-id="element-196">
            La solución no es "relajarse". <br className="hidden md:block" data-id="element-197" />
            <span className="text-cyan-signal" data-id="element-198">Es Bloqueo Mental.</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-199">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="space-y-6 text-steel text-lg leading-relaxed" data-id="element-200">
            <p data-id="element-201">
              En lugar de pedirle amablemente a tu mente que se calle, este
              método utiliza tareas cognitivas estructurales y manipulación
              térmica para forzar al sistema nervioso a pasar del modo "Lucha o
              Huida" al modo "Descanso y Recuperación".
            </p>
            <p data-id="element-202">
              Es una intervención de ingeniería biológica que toma el control
              del termostato de tu cuerpo y de la narrativa de tu cerebro para
              inducir el sueño en menos de 15 minutos.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.4
        }} className="bg-midnight-deep p-8 border border-cyan-signal/20 flex flex-col items-center justify-center gap-8" data-id="element-203">
            <div className="w-full bg-alert/10 border border-alert/30 p-6 text-center" data-id="element-204">
              <span className="font-display text-2xl text-alert uppercase tracking-widest" data-id="element-205">
                Lucha o Huida
              </span>
              <p className="text-alert/70 text-sm mt-2 uppercase font-bold" data-id="element-206">
                Estado Actual
              </p>
            </div>

            <ArrowRight className="w-8 h-8 text-cyan-signal rotate-90 lg:rotate-0" data-id="element-207" />

            <div className="w-full bg-cyan-signal/10 border border-cyan-signal/30 p-6 text-center" data-id="element-208">
              <span className="font-display text-2xl text-cyan-signal uppercase tracking-widest" data-id="element-209">
                Descanso y Recuperación
              </span>
              <p className="text-cyan-signal/70 text-sm mt-2 uppercase font-bold" data-id="element-210">
                Objetivo del Protocolo
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}